/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PROSUPPLIER", "566")
  

// 接口文档



export interface API77586Req {
  
  /**  */
  taskId?: string;
};



export interface API77586Res {
  /** 任务状态PROCESSING：处理中；FINISHED：完成;FAIL：失败  */
  taskStatus?: string;
  /** 语音转文字结果  */
  content?: string;
  
};


// 接口函数 77586 查询语音文件转换结果

export interface IUsePostAPI77586Return {
  /** 查询语音文件转换结果: 接口请求状态 */
  isAPI77586Loading: boolean;
  /** 查询语音文件转换结果: 接口请求返回数据 */
  dataAPI77586: API77586Res;
  /**  查询语音文件转换结果: 接口数据请求方法 */
  fetchAPI77586Data: (inputs: API77586Req, config?: YWRequestConfig) => Promise<API77586Res>;
  /** 查询语音文件转换结果: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI77586 = ():IUsePostAPI77586Return => {
  let isMount = true;
  const [isAPI77586Loading, setIsAPI77586Loading] = useState(false);
  const [dataAPI77586, setDataAPI77586] = useState<API77586Res>({} as API77586Res);
  const requestUrl = `${basePath}/yoaichat-admin/chat/queryVoiceFile`;

  const fetchAPI77586Data = async (inputs: API77586Req, config?: YWRequestConfig): Promise<API77586Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API77586Req>) || {}) as API77586Req;
    
  
    if ( isMount ) {
      setIsAPI77586Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API77586Res>(`${basePath}/yoaichat-admin/chat/queryVoiceFile`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI77586(res || {} as API77586Res);
        setIsAPI77586Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI77586Loading(false);
      }
      return false as unknown as API77586Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI77586Loading,
    dataAPI77586,
    fetchAPI77586Data,
    requestUrl,
  }
}

